<script setup>
import PosteAVerserTabItem from '@/components/fiche-aim/fiche-aim/versements/poste-a-verser-tab-item.vue'
</script>

<template>
  <div>
    <v-chip v-if="postesAVerser.length < 1">
      <v-icon>mdi-arrow-left</v-icon>
      Selectionnez les postes à verser sur le panel de gauche
    </v-chip>
    <v-simple-table dense v-else>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Poste</th>
            <th class="text-left">Montant à verser (en €)</th>
            <th class="text-left">Montant par versement</th>
          </tr>
        </thead>
        <tbody>
          <poste-a-verser-tab-item
            v-for="posteAVerser in postesAVerser"
            :key="posteAVerser.posteAim.posteAIMId"
            :poste-a-verser="posteAVerser"
          />
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'tab-postes-a-verser',
  computed: {
    ...mapGetters({
      postesAVerser: 'preparationVersement_IHM_helper/getPostesVersements',
    }),
  },
}
</script>

<style scoped></style>
